var FavoriteFilter = React.createClass({
    propTypes: {
        showFavoriteFilter: React.PropTypes.bool,
        favoritesOnly: React.PropTypes.bool,
        onFavoriteChanged: React.PropTypes.func
    },
    getDefaultProps() {
        return {
          favoritesOnly: false,
          showFavoriteFilter: false
        }
    },
    handleAllClick () {
        if (this.props.favoritesOnly) {
            this.props.favoritesOnly = false;
            if (this.props.onFavoriteChanged) {
                this.props.onFavoriteChanged(this.props.favoritesOnly);
            }
        }
    },
    handleFavoriteClick () {
        if (!this.props.favoritesOnly) {
            this.props.favoritesOnly = true;
            if (this.props.onFavoriteChanged) {
                this.props.onFavoriteChanged(this.props.favoritesOnly);
            }
        }
    },
    render() {
        this.props.favoritesOnly = this.props.favoritesOnly === "true" || this.props.favoritesOnly === true ? true : false;
        if (Config.isGuestPortal || !this.props.showFavoriteFilter)
            return <span></span>
        return (
            <BrowseFilter title="" filterType="filter-type__favorite" isOpen={this.props.isOpen} ariaLabel="Solution Favorite Filter">
                <div id="favoriteFilter">
                    <nav className="text-center" aria-label="page">
                        <ul className="pagination">
                            <li id="allButton" className={!this.props.favoritesOnly ? 'active' : null}>
                                <a role="button" href="#" onClick={this.handleAllClick}>ALL</a>
                            </li>
                            <li id="favoriteButton" className={this.props.favoritesOnly ? 'active' : null}>
                                <a role="button" href="#" onClick={this.handleFavoriteClick}>FAVORITES</a>
                            </li>
                        </ul>
                    </nav >  
                </div>
            </BrowseFilter> 
        ) 
    }
});